export default __webpack_public_path__ + "static/media/icon-medicos.3a5efb4d.svg";